window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// GSAP
// import {
//     gsap,
//     ScrollTrigger
// } from "gsap/all";
// import {
//     DrawSVGPlugin
// } from "gsap/DrawSVGPlugin";
// gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

// import Swiper bundle with all modules installed
// import Swiper from 'swiper/bundle';
import '@fortawesome/fontawesome-free/js/all.js';

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
const fCarouselsFlex = require('./components/carousels-flex')
const fMainMenu = require('./components/main-menu')
// Vue Support Function
import Vue from 'vue'

const InitVueComponents = () => {
    Vue.component(
        'tab-content',
        () => import('./vue/tab-content.vue')
    );

    Vue.component(
        'gallery',
        () => import('./vue/gallery.vue')
    );

    // Init Vue Instance
    new Vue({
        el: document.getElementById('vue-space')
    })
}

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    fSmoothScroll()
    InitVueComponents()
    fCarouselsFlex.init();
    fMainMenu.init();
})